import React, {useState} from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {getUser, useUserDispatch} from "../UserContext";
import {Avatar, Box, Button, Container, CssBaseline, TextField, Typography} from "@mui/material";
import {ShoppingCartRounded} from "@mui/icons-material";

// const useStyles = makeStyles((theme) => ({
//   paper: {
//     marginTop: theme.spacing(8),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   avatar: {
//     margin: theme.spacing(1),
//     backgroundColor: "#000000",
//   },
//   form: {
//     width: '100%', // Fix IE 11 issue.
//     marginTop: theme.spacing(1),
//   },
//   submit: {
//     margin: theme.spacing(3, 0, 2),
//   },
// }));

function SignIn() {
  // const classes = useStyles();
  const userDispatch = useUserDispatch()

  const [id, setId] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const handleLogin = () => {
    setError(false)
    setErrorMessage('')
    console.log('handleLogin ' + id + ' ' + password)

    axios.get(`${process.env.REACT_APP_USER_API_HOST}/user/logIn`, {
      headers: { 'Content-type': 'application/x-www-form-urlencoded', },
      params: { user_email: id, user_pwd: password, }
    },{ withCredentials: true }).then((response) => {
      console.log('RET_CODE:', response.data);
      if (response.data.code === 200) {
        cookie.save(RECEIVER_COOKIE_KEY, response.data.info, { path: '/',  maxAge: 31556952});

        getUser(userDispatch)

        // history.push('/')
      } else {
        setError(true)
        setErrorMessage('로그인에 실패 하였습니다.')
      }
    }).catch(function (error) {
      console.log(error);
      setError(true)
      setErrorMessage('로그인에 실패 하였습니다.')
    });
  }

  const onKeyPress = (e) => {
    console.log('onKeyPress ' ,e)
    if(e.key === 'Enter'){
      handleLogin()
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box sx={{
        marginTop: (theme) => theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',}}
      >
        <Avatar sx={{
          margin: (theme) => theme.spacing(1),
          backgroundColor: "#000000",
        }}>
          <ShoppingCartRounded />
        </Avatar>
        <Typography component="h1" variant="h5">
          폴슨 상품 입고
        </Typography>
        <TextField
          onKeyPress={(e)=>onKeyPress(e)}
          error={error}
          variant="outlined"
          margin="normal"
          fullWidth
          id="email"
          label="아이디"
          name="email"
          autoComplete="email"
          autoFocus
          value={id}
          onChange={(event => setId(event.target.value))}
        />
        <TextField
          onKeyPress={(e)=>onKeyPress(e)}
          error={error}
          helperText={errorMessage}
          variant="outlined"
          margin="normal"
          fullWidth
          name="password"
          label="패스워드"
          type="password"
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={(event => setPassword(event.target.value))}
        />
        <Button
          onKeyPress={(e) => onKeyPress(e)}
          onClick={handleLogin}
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            margin: (theme) => theme.spacing(3, 0, 2),
          }}
        >
          로그인
        </Button>
      </Box>
    </Container>
  );
}


export default SignIn